import {
    BackspaceOutlined as BackspaceOutlinedIcon,
    DeleteForeverOutlined as DeleteForeverOutlinedIcon,
    EditTwoTone as EditTwoToneIcon,
    Search as SearchIcon,
    VisibilityOutlined as VisibilityOutlinedIcon
} from '@material-ui/icons';
import {
    Box, Button, Card, CardContent, Checkbox, FormControlLabel, Input, MenuItem, Paper, Select, Table,
    TableBody, TableCell, TableHead, TablePagination, TableRow, Tooltip
} from '@material-ui/core';
import { ANAO, ASIM } from 'consts';
import api from '../../../services/api';
import { Link } from 'react-router-dom';
import React, { Component } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import ComboPadraoMultiple from 'views/Components/ComboPadraoMultiple';
import AlertInformation from 'components/AlertInformation/AlertInformation';
import DeleteConfirmationModal from '../../../components/DeleteConfirmationModal/DeleteConfirmationModal';

class VeiculoList extends Component {
    state = {
        searchFilter: JSON.parse(sessionStorage.getItem('veiculoSearchFilter')) || {
            nroveiculo: '',
            descveiculo: '',
            capacidadepax: '',
            marcas: [],
            modelos: [],
            fornecedores: [],
            veiculoproprio: false,
            situacaoInativoFilter: ANAO
        },
        veiculos: [],
        listaMarcas: [],
        listaModelos: [],
        listaFornecedores: [],
        totalItems: 0,
        page: Number(sessionStorage.getItem('veiculoPage')) || 0,
        rowsPerPage: Number(sessionStorage.getItem('veiculoRowsPerPage')) || 10
    };
    estilo = {
        redText: { color: 'red' },
        addButton: {
            height: '42px',
            display: 'flex',
            alignItems: 'center'
        },
        marginTop: 30,
        marginLeft: 30,
        marginRight: 30
    };

    constructor(props) {
        super(props);
    };

    /* Carregamento inicial */
    async componentDidMount() {
        this.loadVeiculos();
        this.loadModelos();
        this.loadMarcas();
        this.loadFornecedores();
    };

    /* Paginação */
    componentDidUpdate(prevState) {
        const { searchFilter, page, rowsPerPage } = this.state;

        // persiste filtros e paginação no sessionStorage
        if (prevState.searchFilter !== searchFilter) {
            sessionStorage.setItem('veiculoSearchFilter', JSON.stringify(searchFilter));
        }
        if (prevState.page !== page) {
            sessionStorage.setItem('veiculoPage', page);
        }
        if (prevState.rowsPerPage !== rowsPerPage) {
            sessionStorage.setItem('veiculoRowsPerPage', rowsPerPage);
        }
    };

    /* Carrega fornecedores */
    loadFornecedores = async () => {
        try {
            const params = `?page=1&limit=500&transportadora=S`
            const response = await api.get(`/fornecedor/active/true${params}`);
            const listaFornecedores = response.data.map(fornecedor => ({
                id: fornecedor.codfornecedor,
                item: fornecedor.descfornecedor
            }));
            this.setState({ listaFornecedores });
        } catch (error) {
            console.error('Erro ao carregar fornecedores do veículo', error);
        }
    };

    /* Carrega marcas */
    loadMarcas = async () => {
        try {
            const response = await api.get('/marcaveiculo');
            const listaMarcas = response.data.map(marca => ({
                id: marca.codmarcaveiculo,
                item: marca.descmarcaveiculo
            }));
            this.setState({ listaMarcas });
        } catch (error) {
            console.error('Erro ao carregar marcas de veículo', error);
        }
    };

    /* Carrega modelos */
    loadModelos = async () => {
        try {
            const response = await api.get('/modeloveiculo');
            const listaModelos = response.data.map((modelo) => ({
                id: modelo.codmodeloveiculo,
                item: modelo.descmodeloveiculo,
                codmarcaveiculo: modelo.codmarcaveiculo
            }));
            this.setState({ listaModelos });
        } catch (error) {
            console.error('Erro ao carregar modelos de veículo:', error);
        }
    };

    /* Carrega veículos */
    loadVeiculos = async () => {
        const { listaModelos, page, rowsPerPage, searchFilter } = this.state;
        const { nroveiculo, descveiculo, capacidadepax, situacaoInativoFilter } = searchFilter;
        
        let params = `?page=${page + 1}&limit=${rowsPerPage}`;

        if (nroveiculo) {
            params += `&NROVEICULO=_like_${nroveiculo}`;
        }

        if (descveiculo) {
            params += `&DESCVEICULO=_like_${descveiculo}`;
        }

        if (capacidadepax) {
            params += `&CAPACIDADEPAX=_gte_${capacidadepax}`
        }

        if (situacaoInativoFilter === ASIM || situacaoInativoFilter === ANAO) {
            params += `&INATIVO=${situacaoInativoFilter}`;
        }

        if (searchFilter.modelos && searchFilter.modelos.length > 0) {
            const codigos = searchFilter.modelos.map(m => m.id);
            params += `&CODMODELOVEICULO=_in_${codigos.join(',')}`;
        }

        if (searchFilter.marcas && searchFilter.marcas.length > 0) {
            // pega os ids das marcas selecionadas
            const codigoMarcas = searchFilter.marcas.map(m => m.id);

            // filtra os modelos que pertencem a essas marcas
            const modelosRelacionados = listaModelos.filter(modelo => codigoMarcas.includes(modelo.codmarcaveiculo)).map(modelo => modelo.id);

            if (modelosRelacionados.length > 0) {
                params += `&CODMODELOVEICULO=_in_${modelosRelacionados.join(',')}`;
            }
        }

        if (searchFilter.fornecedores && searchFilter.fornecedores.length > 0) {
            const codigoFornecedores = searchFilter.fornecedores.map(f => f.id);
            params += `&CODFORNECEDORVEICULO=_in_${codigoFornecedores.join(',')}`;
        }

        if (searchFilter.veiculoproprio === true) {
            params += `&VEICULOPROPRIO=S`;
        }

        try {
            const response = await api.get('/veiculo' + params);
            this.setState({
                veiculos: response.data.data || [],
                totalItems: parseInt(response.data.info && response.data.info.totalrecords, 10) || 0
            });
        } catch (error) {
            console.error('Erro ao carregar veículos:', error);
            this.setState({ veiculos: [], totalItems: 0 });
        }
    };

    /* Muda página */
    handleChangePage = (event, newPage) => {
        this.setState({ page: newPage }, () => this.loadVeiculos());
    };

    /* Muda quantidade por página */
    handleChangeRowsPerPage = (event) => {
        this.setState({ rowsPerPage: parseInt(event.target.value, 10), page: 0 }, () => this.loadVeiculos());
    };

    /* Escolha de um registro para exclusão */
    handleSelectItem = (id, descricao) => {
        this.setState({
            selectedId: id,
            selectedDesc: descricao
        });
    };

    /* Deleta veículo */
    handleDelete = async (id) => {
        try {
            const response = await api.delete(`/veiculo/${id}`);
            // verifica se a exclusão foi bem-sucedida
            if (response.status === 200) {
                this.handleClose();
                this.loadVeiculos();
            }
        } catch (error) {
            this.handleClose();
            this.handleOpenAlert(error.response.data.error);
        }
    };

    /* Abre janela confirmação para exclusão */
    handleOpen = (codveiculo, nroveiculo) => {
        this.setState({ open: true });
        this.handleSelectItem(codveiculo, nroveiculo);
    };

    /* Abre janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.setState({ openAlert: true });
        this.setState({ messageAlert: message });
    };

    /* Fecha janela de confirmação exclusão */
    handleClose = () => {
        this.setState({ open: false });
    };

    /* Fecha janela mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* Pesquisar filtros na tela */
    OnChangeSearch = (event) => {
        const { name, value } = event.target;
        const searchFilter = { ...this.state.searchFilter };

        if (event.target.type === 'checkbox') {
            searchFilter[name] = event.target.checked;
        } else {
            searchFilter[name] = value.toUpperCase();
        }

        this.setState({ searchFilter });
    };

    /* Pesquisar modelos */
    OnChangeModelos = (selected) => {
        const searchFilter = { ...this.state.searchFilter, modelos: selected };
        this.setState({ searchFilter });
    };

    /* Pesquisar marcas */
    OnChangeMarcas = (selected) => {
        const searchFilter = { ...this.state.searchFilter, marcas: selected };
        this.setState({ searchFilter });
    };

    /* Pesquisar fornecedores */
    OnChangeFornecedores = (selected) => {
        const searchFilter = { ...this.state.searchFilter, fornecedores: selected };
        this.setState({ searchFilter });
    };

    /* Pesquisar veículos próprios */
    OnChangeVeiculoPV = (event) => {
        const searchFilter = { ...this.state.searchFilter, veiculoproprio: event.target.checked };
        this.setState({ searchFilter });
    };

    /* Limpa Filtros na tela */
    limpaFiltros = () => {
        const searchFilter = {
            nroveiculo: '',
            descveiculo: '',
            capacidadepax: '',
            situacaoInativoFilter: ANAO,
            modelos: [],
            marcas: [],
            fornecedores: [],
            veiculoproprio: false
        };

        this.setState({ searchFilter }, () => {
            this.loadVeiculos();
        });
    };

    render() {
        const {
            veiculos,
            searchFilter,
            listaModelos,
            listaMarcas,
            listaFornecedores,
            open,
            selectedDesc,
            selectedId,
            openAlert,
            messageAlert,
            totalItems,
            page,
            rowsPerPage
        } = this.state;
        const {
            addButton,
            redText
        } = this.estilo;

        return (
            <div style={this.estilo}>
                <Paper
                    hover
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: 'nowrap',
                        padding: '10px 20px',
                        width: '100%',
                        gap: 15
                    }}
                >
                    <Input
                        autoFocus
                        id="nroveiculo"
                        name="nroveiculo"
                        onBlur={this.onInputBlur}
                        onChange={this.OnChangeSearch}
                        placeholder="Veículo"
                        value={searchFilter.nroveiculo}
                        style={{ width: 200 }}
                    />

                    <Input
                        id="descveiculo"
                        name="descveiculo"
                        onBlur={this.onInputBlur}
                        onChange={this.OnChangeSearch}
                        placeholder="Descrição"
                        value={searchFilter.descveiculo}
                        style={{ width: 150 }}
                    />

                    <Input
                        id="capacidadepax"
                        name="capacidadepax"
                        onBlur={this.onInputBlur}
                        onChange={this.OnChangeSearch}
                        placeholder="Qtde. pax"
                        value={searchFilter.capacidadepax}
                        style={{ width: 75 }}
                    />

                    <Select
                        id="situacaoInativoFilter"
                        name="situacaoInativoFilter"
                        value={searchFilter.situacaoInativoFilter || ''}
                        onChange={this.OnChangeSearch}
                        style={{
                            width: 100,
                            textAlign: 'center'
                        }}
                    >
                        <MenuItem
                            value={ANAO}
                            style={{ justifyContent: 'center' }}
                        >
                            Ativos
                        </MenuItem>

                        <MenuItem
                            value={ASIM}
                            style={{ justifyContent: 'center' }}
                        >
                            Inativos
                        </MenuItem>

                        <MenuItem
                            value={'T'}
                            style={{ justifyContent: 'center' }}
                        >
                            Todos
                        </MenuItem>
                    </Select>

                    <FormControlLabel
                        label="Exibir somente veículos próprios"
                        control={
                            <Checkbox
                                checked={searchFilter.veiculoproprio}
                                name="veiculoproprio"
                                onChange={this.OnChangeSearch}
                                color="primary"
                            />
                        }
                    />

                    <span style={{ display: 'inline-flex', gap: 5 }}>
                        <Tooltip
                            title="Procurar"
                            enterDelay={50}
                        >
                            <SearchIcon
                                onClick={() => this.loadVeiculos()}
                                onMouseEnter={(e) => e.currentTarget.style.color = '#1976d2'}
                                onMouseLeave={(e) => e.currentTarget.style.color = '#0000ee'}
                                style={{
                                    fontSize: 24,
                                    color: '#0000ee',
                                    cursor: 'pointer'
                                }}
                            />
                        </Tooltip>

                        <Tooltip
                            title="Limpar"
                            enterDelay={50}
                        >
                            <BackspaceOutlinedIcon
                                onClick={() => this.limpaFiltros()}
                                onMouseEnter={(e) => e.currentTarget.style.color = '#1976d2'}
                                onMouseLeave={(e) => e.currentTarget.style.color = '#0000ee'}
                                style={{
                                    fontSize: 24,
                                    color: '#0000ee',
                                    cursor: 'pointer'
                                }}
                            />
                        </Tooltip>
                    </span>

                    <div style={{ flex: 1 }} />

                    <Button
                        component={Link}
                        to="/frotas/veiculo/novo"
                        variant="contained"
                        color="primary"
                        style={addButton}
                    >
                        Novo
                    </Button>
                </Paper>

                <br />

                <Paper
                    hover
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: 'nowrap',
                        padding: '10px 20px',
                        width: '100%',
                        gap: 15
                    }}
                >
                    <Box style={{ width: 200 }}>
                        <ComboPadraoMultiple
                            options={searchFilter.marcas}
                            label="Marcas"
                            itens={listaMarcas}
                            onSelectionChange={this.OnChangeMarcas}
                        />
                    </Box>

                    <Box style={{ width: 200 }}>
                        <ComboPadraoMultiple
                            options={searchFilter.modelos}
                            label="Modelos"
                            itens={listaModelos}
                            onSelectionChange={this.OnChangeModelos}
                        />
                    </Box>

                    <Box style={{ width: 250 }}>
                        <ComboPadraoMultiple
                            options={searchFilter.fornecedores}
                            label="Fornecedores"
                            itens={listaFornecedores}
                            onSelectionChange={this.OnChangeFornecedores}
                        />
                    </Box>
                </Paper>

                <br />

                <Card>
                    <CardContent>
                        <PerfectScrollbar>
                            <div>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="center">Código</TableCell>

                                            <TableCell align="center">Veículo</TableCell>

                                            <TableCell align="center">Capacidade Pax</TableCell>

                                            <TableCell align="center">Ações</TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {veiculos.map(veiculo => (
                                            <TableRow
                                                hover
                                                key={veiculo.codveiculo}
                                            >
                                                <TableCell
                                                    align="center"
                                                    style={(veiculo.inativo === ASIM) ? redText : {}}
                                                >
                                                    {veiculo.codveiculo}
                                                </TableCell>

                                                <TableCell
                                                    align="center"
                                                    style={(veiculo.inativo === ASIM) ? redText : {}}
                                                >
                                                    {veiculo.nroveiculo}
                                                </TableCell>

                                                <TableCell
                                                    align="center"
                                                    style={(veiculo.inativo === ASIM) ? redText : {}}
                                                >
                                                    {veiculo.capacidadepax}
                                                </TableCell>

                                                <TableCell align="center">
                                                    <Tooltip
                                                        title="Editar"
                                                        enterDelay={50}
                                                    >
                                                        <Link to={`/frotas/veiculo/${veiculo.codveiculo}`}>
                                                            <EditTwoToneIcon
                                                                onMouseEnter={(e) => e.currentTarget.style.color = '#1976d2'}
                                                                onMouseLeave={(e) => e.currentTarget.style.color = '#0000ee'}
                                                                style={{
                                                                    cursor: 'pointer',
                                                                    color: '#0000ee',
                                                                    marginRight: 6
                                                                }}
                                                            />
                                                        </Link>
                                                    </Tooltip>

                                                    <Tooltip
                                                        title="Visualizar"
                                                        enterDelay={50}
                                                    >
                                                        <Link to={`/frotas/veiculo/${veiculo.codveiculo}/view`}>
                                                            <VisibilityOutlinedIcon
                                                                onMouseEnter={(e) => e.currentTarget.style.color = '#1976d2'}
                                                                onMouseLeave={(e) => e.currentTarget.style.color = '#0000ee'}
                                                                style={{
                                                                    cursor: 'pointer',
                                                                    color: '#0000ee',
                                                                    marginRight: 6
                                                                }}
                                                            />
                                                        </Link>
                                                    </Tooltip>

                                                    <Tooltip
                                                        title="Excluir"
                                                        enterDelay={50}
                                                    >
                                                        <DeleteForeverOutlinedIcon
                                                            onMouseEnter={(e) => e.currentTarget.style.color = 'red'}
                                                            onMouseLeave={(e) => e.currentTarget.style.color = ''}
                                                            onClick={() => this.handleOpen(
                                                                veiculo.codveiculo,
                                                                veiculo.nroveiculo
                                                            )}
                                                            style={{
                                                                cursor: 'pointer'
                                                            }}
                                                        />
                                                    </Tooltip>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </div>
                        </PerfectScrollbar>
                    </CardContent>
                </Card>

                <TablePagination
                    component="div"
                    count={totalItems}
                    page={page}
                    onPageChange={this.handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={this.handleChangeRowsPerPage}
                    rowsPerPageOptions={[10, 50, 100, 200]}
                    labelRowsPerPage="Registros por página"
                />

                <DeleteConfirmationModal
                    open={open}
                    handleClose={() => this.handleClose()}
                    itemId={selectedId}
                    message={`Confirma exclusão do veículo ${selectedDesc || ''} [${selectedId}]?`}
                    handleDelete={() => this.handleDelete(selectedId)}
                />

                <AlertInformation
                    open={openAlert}
                    handleClose={() => this.handleCloseAlert()}
                    message={messageAlert}
                />
            </div>
        );
    }
}

export default VeiculoList;